export default __webpack_public_path__ + "static/media/slide-icon.ff5b1d13.svg";